// extracted by mini-css-extract-plugin
module.exports = {"imageGroupWrap":"ImagePreview_imageGroupWrap__GMDWh","imagePreviewWrap":"ImagePreview_imagePreviewWrap__l_5Mz"};